import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { forgeCustomFieldTypeResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import AsyncSidebarGlobalSettingsIssues from '@atlassian/jira-navigation-apps-sidebar-global-settings-issues/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { fieldContextConfigPageResource } from '@atlassian/jira-router-resources-forge-field-context-config/src/index.tsx';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global/src/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { forgeFieldContextualConfigurationRoute } from '@atlassian/jira-router-routes-forge-routes/src/forgeFieldContextualConfigurationRoute.tsx';
import ForgeFieldContextConfigPage, {
	LazyForgeFieldContextConfigPage,
} from './ui/field-context-config/index.tsx';

export const forgeFieldContextualConfigurationRouteEntry = createEntry(
	forgeFieldContextualConfigurationRoute,
	() => ({
		component: ForgeFieldContextConfigPage,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_ISSUES_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsIssues,
		},

		resources: [
			...getNavigationResources(),
			forgeCustomFieldTypeResource,
			fieldContextConfigPageResource,
			navigationSidebarGlobalResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyForgeFieldContextConfigPage],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-forge-entries/src/forgeFieldContextualConfigurationRouteEntry.tsx',
				whichExportToUse: 'forgeFieldContextualConfigurationRouteEntry',
			},

			enabled: true,
		},
	}),
);
